mutation UpdateTagType($id: ID!, $input: UpdateTagTypeInput!) {
  updateTagType(id: $id, input: $input) {
    id
    title
    featured
    seoDescription
    defaultPreviewType
    customFields {
      type
      name
      label
      required
      multiple
      placeholder
      helperText
      options {
        value
        label
      }
    }
  }
}
